<template>
    <section id="page3">
        <div class="container container-top">
            <div class="col-unique">
                <h2>
                    Avance na experiência e aprendizagem do seu colaborador
                </h2>
                <p>E acompanhe os resultados com relatórios personalizados que apoiam sua tomada de decisão.</p>
            </div>
        </div>
        <div class="container container-bottom">
            <div class="col-left">
                <!-- <img src="@/assets/img/page3-img1.png" alt=""> -->
                <lottie-player :src="`animas/0/page03.json`" v-if="persona==0" ref="lottiepage3" id="page3anima0" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
                    <lottie-player :src="`animas/1/page03.json`" v-if="persona==1" ref="lottiepage3" id="page3anima1" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
            </div>
            <div class="col-right">
                <div class="playvideo" @click="openDialog()">
                    <iframe src="https://www.youtube.com/embed/UEUs4aUOAsA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div> 
        <dialog class="videodialog" ref="dialog" @click="closeDialog()">
            <button class="dialog-close" @click="closeDialog()"><img src="@/assets/img/icon-close.svg" alt=""></button>
            <div class="dialog-container">
                <div class="video-container" v-if="videoModalStatus">
                    <iframe src="https://www.youtube.com/embed/UEUs4aUOAsA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </dialog>
    </section>
</template>
<script>
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona'],
    data() {
        return {
            videoModalStatus: false
        }
    },
    methods: {
        openDialog() {
            this.videoModalStatus = true;
            this.$refs.dialog.showModal();
        },
        closeDialog() {
            this.videoModalStatus = false;
            this.$refs.dialog.close();
        },
        // finished() {
        //     console.log("FINISHEEEED");
        // }
    },
    mounted() {
        if(this.persona == 0) {
            this.$refs.lottiepage3.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page3anima0',
                        actions: [
                            {
                                visibility:[0, 0.2],
                                type: "stop",
                                frames: [0]
                            },
                            {
                                visibility: [0.2, 0.6],
                                type: "seek",
                                frames: [1, 150]
                            }

                        ],
                });
            })
        } else {
            this.$refs.lottiepage3.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page3anima1',
                        actions: [
                            {
                                visibility:[0, 0.2],
                                type: "stop",
                                frames: [0]
                            },
                            {
                                visibility: [0.2, 0.6],
                                type: "seek",
                                frames: [1, 150]
                            }

                        ],
                });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
section {
    background-image: url("~@/assets/img/page3-bg.svg");
    background-repeat: no-repeat;
    background-size: auto;
    background-attachment: fixed;
    background-position: center top;
    // background-color: $color-secondary;
    // color: white;
    position: relative;
    .container-top {
        padding-top: 40px;
        .col-unique {
            display: flex;
            flex-direction: column;
            align-items: center;
            h2 {
                max-width: 802px;
                padding-bottom: 38px;
            }
            p {
                max-width: 525px;
                padding-bottom: 75px;
            }
        }
    }
    .container-bottom {
        padding-bottom: 200px;
        .col-left {
            .anima {
                max-width: 449px;
                margin: 0 auto;
            }
        }
        .col-right {
            flex-grow: 1;
            .playvideo {
                
                position: relative;
                padding-bottom: 56.25%; /* 16:9 */
                height: 0;
                iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .videodialog {
        background-color: transparent;
        width: 100vw;
        height: 100vh;
        border: 0;
        &::backdrop {
            background: rgba(0, 0, 0, .5);
        }
        .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: transparent;
            border: 0;
            cursor: pointer;
        }
        .dialog-container {
            width: 70vw;
            height: 80vh;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .video-container {
                overflow: hidden;
                position: relative;
                width:100%;
                &::after {
                    padding-top: 56.25%;
                    display: block;
                    content: '';
                }
                iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    @media only screen and (max-width: 1100px) {
        .container-bottom {
            .col-left, .col-right, .col-center {
                margin-left: $column-lateral-margin;
                margin-right: $column-lateral-margin;
            }
            flex-direction: column;
            .col-left {
                padding-bottom: 30px;
            }
            .col-right {
                width: 90%;
                height: auto;
            }
        }
    }
     @media only screen and (max-width: 710px) {
        .container-bottom {
            .col-right {
                .playvideo {
                    img {
                        max-width: none;
                        width: 100%;
                    }
                }
            }
            .col-left {
                .anima {
                    // padding-left: 25px;
                    // padding-right: 25px;
                    width: calc(100%);
                }
            }
        }

     }
}
</style>